export default __webpack_public_path__ + "static/media/Group 8706_8.dc3db096.png";